import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import Term from 'src/models/AP/Term';
import useFetch from 'use-http';

interface IAPTermsDialogProps {
    dialogName: string;
    handleTerms?: (terms: Term[]) => void;
    hideDialog: () => void;
}

const termsList = [
    { id: 1, termNumber: 0, description: 'Upon Receipt', days: 0},
    { id: 2, termNumber: 1, description: 'Net 15', days: 15},
    { id: 3, termNumber: 2, description: 'Net 30', days: 30},
    { id: 4, termNumber: 3, description: 'Net 45', days: 45},
    { id: 5, termNumber: 4, description: '', days: null},
];

const APTermsDialog = (props: IAPTermsDialogProps) => {
    const { register, errors, getValues, formState } = useForm();
    const [terms, setTerms] = useState<Term[]>();
    const { get, post, response } = useFetch();    
    const { isDirty } = formState;

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        console.log();
    }, [terms]);

    const onCreate = () => {
        console.log('APTermsDialog onCreate()');
        getTerms();
        initializeData();
    };

    const initializeData = () => {
        // let blankTerm: Term = {id: termsList?.length + 1, termNumber: termsList[termsList?.length - 1].termNumber + 1, description: '', days: null};

        // termsList.push(blankTerm);
        setTerms(termsList);

        console.log();
    };

    const finalizeData = () => {
        let values = getValues().terms;
        let newTerm = values?.pop();
        let newTermIndex = terms?.pop().id;

        console.log();

        let term: Term = {
            id: newTermIndex,
            termNumber: newTermIndex - 1,
            description: newTerm.description,
            days: parseInt(newTerm.days, 10)
        };

        termsList.push(term);

        setTerms(termsList);

        return termsList;
    };

    const getTerms = async () => {
        let result = await get(`/v1.0/AccountsPayable/vendors/terms`);

        if (response.ok) {
            setTerms([]);
            setTerms(result);
        } else {
            console.log('Unable to get Terms Data!!!');
        }
    };

    const addTerm = async (term: Term) => {
        await post(`/v1.0/AccountsPayable/vendors/terms/create`, term);

        if (response.ok) {
            getTerms();
        } else {
            console.log('Unable to create Term!');
        }
    };

    const saveClicked = () => {
        const values = getValues();
        const data = finalizeData();

        if (isDirty) {
            // This table isn't used much or at all in the legacy DLC Menu system
            // Here is where we would detect what has change and call an UPDATE term function or
            // detect if a new term as added and call the addTerm function below.
            if (values?.terms?.length > terms.length) {
                // New terms have been added, iterate through the values.terms collection and
                // 1) determine which rows have been updated and call UPDATE term (not implemented) for those rows and
                // 2) determine which rows are new and call addTerm for those 
                addTerm(new Term());
            }
        }

        props.handleTerms(data);
        // props.hideDialog();

        console.log(data, values);
    };

    return (
        <Dialog title="AP Terms" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '30%' }}>
            <div style={{marginTop: '3rem'}}>
                <form>
                    <table>
                        <thead style={{ textAlign: 'left' }}>
                            <tr>
                                <th>Term #</th>
                                <th>Description</th>
                                <th>Days</th>
                            </tr>
                        </thead>
                        {terms?.map((term: Term, index: number) => {
                            return (
                                <tbody key={term.id}>
                                    <tr className="table-item-hover" style={{ textAlign: 'left' }}>
                                        <td style={{ width: '20%' }}>
                                            <label>{term.termNumber}</label>
                                            {/* <RHFInputBox
                                                name={`terms[${index}].termNumber`}
                                                type="text"
                                                defaultVal={term.termNumber + ''}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            /> */}
                                        </td>
                                        <td style={{ width: '60%' }}>
                                            <RHFInputBox
                                                name={`terms[${index}].description`}
                                                type="text"
                                                defaultVal={term.description}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            <RHFInputBox
                                                name={`terms[${index}].days`}
                                                type="number"
                                                defaultVal={term.days + ''}
                                                register={register}
                                                errors={errors}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ width: '100%' }}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                                );
                            })}
                    </table>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', marginLeft: '33%', textAlign: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Save'}
                    onClick={() => saveClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Exit'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default APTermsDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/APTermsDialog.tsx